export default __webpack_public_path__ + "favicon-32x32.v2.3cca7b8c01894f508f20ca8a042dfadd.png";